<style lang="scss">
.sp-code-mirror {
  display: flex;
  height: 100%;
  justify-content: space-between;
  .codemirror {
    width: calc(50% - 5px);
    margin: 0;
    overflow: auto;
  }
}
// .el-form-item__content {
//   line-height: 24px;
// }
.el-card__header {
  padding: 10px 15px;
  .head-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.el-card__body {
  padding: 0;
}
.CodeMirror {
  height: 500px;
}
</style>
<template>
  <div class="sp-code-mirror">
    <div class="codemirror">
      <el-card>
        <div slot="header">
          <div class="head-box">
            <span>原始碼</span>
            <el-button @click="handleRunCode" size="small" type="primary">執行程式碼</el-button>
          </div>
        </div>
        <div>
          <codemirror
            :value="value"
            placeholder="Code goes here..."
            :options="cmOption"
            @input="onCmCodeChange"
          ></codemirror>
        </div>
      </el-card>
    </div>
    <div class="codemirror">
      <el-card>
        <div slot="header">
          <div class="head-box">
            <span>執行結果</span>
            <div>
              <div style="height: 34px; line-height: 34px"></div>
            </div>
          </div>
        </div>
        <div>
          <iframe frameborder="0" :srcdoc="runCode" style="height: 500px; width: 100%"></iframe>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { codemirror } from 'vue-codemirror'
// base style
import 'codemirror/lib/codemirror.css'
// theme css
import 'codemirror/theme/rubyblue.css'
// html程式碼高亮
import 'codemirror/mode/htmlmixed/htmlmixed.js'
// 語言模式
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/mode/css/css.js'
import 'codemirror/mode/htmlmixed/htmlmixed.js'

// #region 搜尋功能
// find：Ctrl-F (PC), Cmd-F (Mac)
// findNext：Ctrl-G (PC), Cmd-G (Mac)
// findPrev：Shift-Ctrl-G (PC), Shift-Cmd-G (Mac)
// replace：Shift-Ctrl-F (PC), Cmd-Alt-F (Mac)
// replaceAll：Shift-Ctrl-R (PC), Shift-Cmd-Alt-F (Mac)
import 'codemirror/addon/dialog/dialog.css'
import 'codemirror/addon/dialog/dialog'
import 'codemirror/addon/search/searchcursor'
import 'codemirror/addon/search/search'
import 'codemirror/addon/search/jump-to-line'
import 'codemirror/addon/search/matchesonscrollbar'
import 'codemirror/addon/search/match-highlighter'
// #endregion

// 程式碼自動提示和補全
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/hint/show-hint.js'
import 'codemirror/addon/hint/anyword-hint'
import 'codemirror/addon/hint/html-hint'
import 'codemirror/addon/hint/css-hint'
import 'codemirror/addon/hint/javascript-hint'

// 顯示自動重新整理
import 'codemirror/addon/display/autorefresh.js'

import 'codemirror/addon/lint/lint.js'
import 'codemirror/addon/lint/lint.css'

export default {
  name: 'SpCodeMirror',
  components: {
    codemirror
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      cmOption: {
        mode: 'text/html', // 語言及語法模式
        line: true, // 顯示函式
        theme: 'default', // 主題
        tabSize: 4, // 製表符的寬度
        lineNumbers: true, // 是否顯示行號
        autofocus: true,
        autoRefresh: true,
        styleActiveLine: true, // 高亮行功能
        hintOptions: {
          // 避免由於提示列表只有一個提示資訊時，自動填充
          completeSingle: false
        }
      },
      runCode: ''
    }
  },
  created() {},
  methods: {
    onCmCodeChange(newCode) {
      this.$emit('input', newCode)
    },
    handleRunCode() {
      this.runCode = ''
      this.$forceUpdate()
      setTimeout(() => {
        this.runCode = this.value
      }, 100)
    }
  }
}
</script>
